import { useEffect, useRef, useState } from "react";

/** Keep SVG text at readable sizes when a chart moves between a phone and a desktop grid. */
export function useChartWidth(initial: number) {
  const ref = useRef<HTMLElement>(null);
  const [width, setWidth] = useState(initial);
  useEffect(() => {
    if (!ref.current) return;
    const observer = new ResizeObserver(([entry]) => setWidth(Math.max(220, Math.round(entry.contentRect.width))));
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
  return { ref, width };
}
